import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Form, Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { error } from 'jquery';
const AddLead = ({ show, onClose, refresh, count }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [lead_name, setname] = useState('');
    const [mobile_no, setMobileno] = useState('');
    const [email_id, setEmailid] = useState('');
    const [company_name, setCompname] = useState('');
    const [company_mobile_no, setCompMobileno] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [address, setAddress] = useState('');
    const [description, setdescription] = useState('');
    const [lead_type, setLeadtype] = useState(null);
    const [lead_source, setLeadsource] = useState('');

    const [leadTypeOptions, setLeadTypeOptions] = useState([]);
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    //lead type
    useEffect(() => {
        const fetchLeadTypes = async () => {
          try {
            const response = await axios.get(`${baseURL}/getleadtype`);
            const formatted = response.data.data.map(item => ({
              value: item.sno,
              label: item.leadtype_name,
            }));
            setLeadTypeOptions(formatted);
          } catch (error) {
            console.log('Error fetching lead types:', error);
          }
        };

        fetchLeadTypes();
    }, []);
    // lead source
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
              const response = await axios.get(`${baseURL}/getleadsource`);
              const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.leadsource_name,
              }));
              setLeadSourceOptions(formattedsource);
            } catch (error) {
              console.log('Error fetching lead source:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const [productoptions, setProductoption] = useState([]);
    const [product, setSelectedProducts] = useState('');
    useEffect(() => {
        const fetchdata = async () => {
          try {
            const response = await axios.get(`${baseURL}/manage-products/products/active`);
            const formatted = response.data.data.map(item => ({
              value: item.sno,
              label: item.product_name,
            }));
            setProductoption(formatted);
          } catch (error) {
            console.log('Error fetching data', error);
          }
        };

        fetchdata();
    }, []);

    const handleProductChange = (selectedOptions) => {
        const ids = selectedOptions.map(option => option.value).join(','); // converts to "1,5,9"
        setSelectedProducts(ids);
    }
    
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
              const response = await axios.get(`${baseURL}/dropdown/area`, {params: {branch_id: branch_id}});
              const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
              }));
              setAreaOption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [userName, setUserName] = useState("");
    const [staffUserID, setStaffUserID] = useState(0);
    
    useEffect(() => {
        const token = localStorage.getItem("token");
        // console.log(token);
        if (token) {
        axios
            .get(`${baseURL}/me`, {
            headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setUserName(res.data.name || "User");
                setStaffUserID(res.data.id);
            })
            .catch((err) => {
                console.log("Failed to fetch user info:", err);
                setUserName("User");
            });
        } else {
            setUserName("Guest");
        }
    }, []);

    
    const [data_name, setData] = useState([]);
    const [data_mobile, setMob] = useState([]);
    const [data_email, setem] = useState([]);

    useEffect(() => {
        const params = {
            branch_id: branch_id
        };
        // axios.get(`${baseURL}/managelead`, { params: params })
        axios.get(`${baseURL}/managelead/all_lead`)
          .then(response => {
            setData(response.data.data.map(mode => mode.lead_name?.toLowerCase?.() || ''));
            setMob(response.data.data.map(mode => mode.mobile_no));
            setem(response.data.data.map(em => em.email_id?.toLowerCase()).filter(email => email));
          })
          .catch(error => {
            console.log('There was an error fetching the data!', error);
          });
    }, [])

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;

        if (!lead_name.trim()) {
            newErrors.name = "This Field is Required.";
            // return newErrors;
        } else if (!regex.test(lead_name)) {
            newErrors.name = "Not a Valid Name";
            // return newErrors;
        } 
        // else if (data_name.includes(lead_name.trim().toLowerCase())) {
        //     newErrors.name = "This Name Already Exists";
        //     // return newErrors;
        // }
        
        if (!mobile_no) {
            newErrors.mob = "This Field is Required.";
        } else if (data_mobile.some(num => num.toString() === mobile_no.trim())) {
            newErrors.mob = "This Number Already Exists.";
        } else if (mobile_no.length < 10) {
            newErrors.mob = "Enter a Valid Number.";
        } else if (!/^[6-9]\d{9}$/.test(mobile_no)) {
            newErrors.mob = "Enter a Valid Number.";
        }

        if(email_id && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_id))){
            newErrors.email = "Invalid Email.";
        }

        if(email_id && data_email.includes(email_id.trim().toLocaleLowerCase())) {
            newErrors.email = "This Email Already Exists.";
        }

        if (!area) {
            newErrors.area = "This Field is Required.";
        }

        if (!lead_source) {
            newErrors.source = "This Field is Required.";
        }

        if (!lead_type) {
            newErrors.type = "This Field is Required.";
        }

        if(lead_type === 2) {
            if (!company_name) {
                newErrors.comp_name = "This Field is Required.";
            }
            if (!company_mobile_no) {
                newErrors.comp_mob = "This Field is Required.";
            }
        }

        return newErrors;
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            lead_name, 
            mobile_no, 
            email_id, 
            latitude, longitude, 
            address, 
            description, 
            lead_type, 
            lead_source, 
            product, area, 
            sales_person: userName, 
            created_by: staffUserID, 
            branch_id: branch_id,
            company_name,
            company_mobile_no,
        };

        axios.post(`${baseURL}/managelead`, postData)
            .then(response => {
                onClose();
                refresh();
                count();
                if(response.data.type === 1){
                    toast.success("Lead Created Successfully!");
                } else if (response.data.type === 3){
                    toast.success("Catering Lead Created Successfully!");
                } else if (response.data.type === 2){
                    toast.success("Corporate Lead Created Successfully!");
                }
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Lead Creation Failed");
            });
    };


    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Lead</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Lead Type <span className="required">*</span></label>
                            <Select  placeholder="Select Lead Type"
                                options={leadTypeOptions}
                                onChange={(selectedOption) => setLeadtype(selectedOption?.value || '')}
                            />
                            {errors.type && <div className="text-danger fs-8 mt-1">{errors.type}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            {/* {lead_type !== 1 && lead_type !== 3 ? (<label className="text-black font-w500 fs-7">Company Name<span className="required">*</span></label>) : (<label className="text-black font-w500 fs-7">Lead Name<span className="required">*</span></label>)} */}
                            <label className="text-black font-w500 fs-7">Lead Name<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Lead Name" 
                                maxLength={100}
                                value={lead_name} 
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    setname(formatName(onlyAlphabets));
                                  }}
                            />
                            {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Mobile No<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Mobile No" 
                                maxLength={10}
                                value={mobile_no} 
                                onChange={(e) => {
                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                    setMobileno(onlyNums);
                                }}
                            />
                            {errors.mob && <div className="text-danger fs-8 mt-1">{errors.mob}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Email ID</label>
                            <input type="text" className="form-control" placeholder="Enter Email ID" 
                                maxLength={100}
                                value={email_id} 
                                onChange={(e) => setEmailid(e.target.value)} 
                            />
                            {errors.email && <div className="text-danger fs-8 mt-1">{errors.email}</div>}
                        </div>
                        
                        {lead_type === 2 && (
                            <>
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">Company Name<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Company Name" 
                                        maxLength={100}
                                        value={company_name} 
                                        onChange={(e) => {
                                            const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                            setCompname(formatName(onlyAlphabets));
                                        }}
                                    />
                                    {errors.comp_name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">Company Mobile No<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Company Mobile No" 
                                        maxLength={10}
                                        value={company_mobile_no} 
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                            setCompMobileno(onlyNums);
                                        }}
                                    />
                                    {errors.comp_mob && <div className="text-danger fs-8 mt-1">{errors.mob}</div>}
                                </div>
                            </>
                        )}

                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Area <span className="required">*</span></label>
                            <Select
                                onChange={(e) => setArea(e?.value || null)}
                                options={areaOption}
                                placeholder="Select Area"
                            />
                            {errors.area && <div className="text-danger fs-8 mt-1">{errors.area}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Lead Source <span className="required">*</span></label>
                            <Select  placeholder="Select Lead Source"
                                options={leadSourceOptions}
                                onChange={(selectedOption) => setLeadsource(selectedOption?.value || '')}
                            />
                            {errors.source && <div className="text-danger fs-8 mt-1">{errors.source}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Product</label>
                            <Select  placeholder="Select Product" isMulti
                                options={productoptions}
                                onChange={handleProductChange}
                            />
                        </div>
                        {/* <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Latitude</label>
                            <input type="text" className="form-control" placeholder="Enter Latitude" 
                                maxLength={100}
                                value={latitude} 
                                onChange={(e) => setLatitude(e.target.value)} 
                            />
                        </div> */}
                        {/* <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Longitude</label>
                            <input type="text" className="form-control" placeholder="Enter Longitude" 
                                maxLength={100}
                                value={longitude} 
                                onChange={(e) => setLongitude(e.target.value)} 
                            />
                        </div> */}
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Address</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Enter Address"
                                maxLength={250}
                                value={address} 
                                onChange={(e) => setAddress(formatName(e.target.value))} 
                            />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Enter Description"
                                maxLength={255}
                                value={description} 
                                onChange={(e) => setdescription(formatName(e.target.value))} 
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <Button type="submit" className="btn btn-sm btn-primary">Create Lead <i className="fas fa-angle-double-right ms-2"></i></Button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddLead;
